import React, { useEffect, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';
import { TOAST_EVENT, type ToastEventDetail } from '@/utils/toast';

export const ToastHost: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [detail, setDetail] = useState<ToastEventDetail | null>(null);

  useEffect(() => {
    function onToast(e: Event) {
      const ce = e as CustomEvent<ToastEventDetail>;
      setDetail(ce.detail);
      setOpen(true);
    }
    window.addEventListener(TOAST_EVENT, onToast as EventListener);
    return () => window.removeEventListener(TOAST_EVENT, onToast as EventListener);
  }, []);

  return (
    <Snackbar
      open={open}
      autoHideDuration={detail?.durationMs ?? 4000}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        onClose={() => setOpen(false)}
        severity={detail?.severity ?? 'info'}
        variant='filled'
        sx={{ width: '100%' }}
      >
        {detail?.message}
      </Alert>
    </Snackbar>
  );
};
